module.exports = __webpack_public_path__ + "static/media/addLane.cc89ac5f.svg";